import type { RouteDefinition } from "./route-definition.ts";

export const officeDisplays = [
  "beltholder",
  "campaign-board",
  "coworld-growth",
  "atlas",
] as const;

export const officeRoutes = {
  "office.display": {
    path: "/unlisted/office/:display",
    scope: "static",
    bucket: "unlisted",
    entry: "direct",
    disposition: "page",
  },
  "office.atlas": {
    path: "/unlisted/office/atlas",
    scope: "static",
    bucket: "unlisted",
    entry: "direct",
    disposition: "document",
  },
} as const satisfies Record<string, RouteDefinition>;
